<div class="deleteButton">
    <mat-icon class="example-icon text-red-500 cursor-pointer" aria-hidden="false" matTooltip="Delete" (click)="onClick($event)" svgIcon="mat_solid:delete"></mat-icon>
</div>